import React from "react";
import "./App.css";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  Routes,
  RouterProvider,
} from "react-router-dom";
import Main from "../src/pages/main";
import MainDesktop from "../src/pages/mainDesktop";
import BadgePreview from "./pages/badgePreview";
import RewardsPage from "./pages/rewards";
import RewardsPageDesktop from "./pages/rewardsDesktop";
import BadgePreviewDesktop from "./pages/badgePreviewDesktop";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/">
      <Route index element={<Main />} />
      <Route path="main" element={<Main />} />
      <Route path="main-desktop" element={<MainDesktop />} />
      <Route path="badge/:id" element={<BadgePreview />} />
      <Route path="rewards" element={<RewardsPage />} />
      <Route path="rewards-desktop" element={<RewardsPageDesktop />} />
      <Route path="badge-desktop/:id" element={<BadgePreviewDesktop />} />
    </Route>
  )
);

function App() {
  return (
    <div>
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
